import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { RouteNamesNonAuth } from './enum'
import { useContext } from 'react'
import { AuthContext } from 'contexts/AuthContext'

export const AuthRoutes = () => {
  const { isSignedIn } = useContext(AuthContext)
  const location = useLocation()

  return isSignedIn ? (
    <Outlet />
  ) : (
    <Navigate to={RouteNamesNonAuth.LOGIN} replace state={{ from: location }} />
  )
}
